import queryString from 'query-string';
import { get } from 'lodash';
// import { push } from 'react-router-redux';
import { setAccessToken } from '@keypr/redux-json-api';
import moment from 'moment-timezone';
import loadingActions from './loading';
import affiliateActions from './affiliates';
import crud from './crud';

import {
  PERFORM_AUTH,
  REDIRECT_LOGIN,
  USER_LOGGEDIN,
  USER_LOGOUT,
  AUTH_OK,
} from '../types';

const { UserPermissions } = require('../../utils/user-permissions').default;

const fetchUser = function fetchUser(oauthData) {
  return function fetchUserFunction(dispatch) {
    return dispatch(crud.apiRead({
      type: 'user',
      options: {
        retries: 3,
      },
    }))
      .then((user) => {
        UserPermissions.setSuperUser(user.data.attributes.is_superuser || false);
        const { data: {
          id,
        } } = user;
        dispatch({
          type: USER_LOGGEDIN,
          payload: {
            id,
          },
        });

        if (window.onLogin) {
          window.onLogin({
            id,
            first_name: user.data.attributes.first_name,
            last_name: user.data.attributes.last_name,
            is_superuser: user.data.attributes.is_superuser,
            email: user.data.attributes.email,
            primary_phone: user.data.attributes.primary_phone,
            is_active: user.data.attributes.is_active,
            pin_code: user.data.attributes.pin_code,
          }, oauthData);
        }

        dispatch(loadingActions.setStatus('retrieving affiliate info'));
        return dispatch(affiliateActions.retrieveAffiliateInfo());
      })
      .then(() => {
        dispatch(loadingActions.setStatus('redirecting user'));
        dispatch(affiliateActions.redirectAffiliate());
      })
      .catch((err) => {
        console.error(err);
      });
  };
};

const login = function login() {
  return function loginFunction(dispatch, getState) {
    const {
      app,
    } = getState();
    return dispatch({
      type: REDIRECT_LOGIN,
      payload: app,
    });
  };
};

const performAuth = function performAuth() {
  return function performAuthFunction(dispatch, getState) {
    let user;
    const { api } = getState();
    if (api.user) {
      user = api.user.data[0];
    }
    let isLoggedIn = false;
    let tokenData = window.localStorage.getItem('oauth_token');
    if (!tokenData) {
      tokenData = `{"oauth":{"expires_on": "${moment().subtract(1, 'hours').toISOString()}"}}`;
    }
    const tokenInfo = JSON.parse(tokenData);
    if (moment().diff(moment(tokenInfo.oauth.expires_on)) > 0) {
      dispatch({
        type: PERFORM_AUTH,
      });
      dispatch(login());
    } else {
      dispatch(setAccessToken(tokenInfo.oauth.access_token));
      if (!user) {
        dispatch(fetchUser(tokenInfo.oauth))
          .then(() => {
            isLoggedIn = true;
            dispatch({
              type: AUTH_OK,
              isLoggedIn,
            });
          });
      } else {
        isLoggedIn = true;
        dispatch({
          type: AUTH_OK,
          isLoggedIn,
        });
      }
    }
  };
};

const parseAuth = function parseAuth(hash) {
  return function parseAuthFunction(dispatch) {
    const parameterMap = queryString.parse(hash);
    const expiresIn = parameterMap['/expires_in'] || parameterMap.expires_in;
    const token = {
      oauth: {
        access_token: parameterMap.access_token,
        expires_on: moment().add(parseInt(expiresIn, 10), 'seconds').toISOString(),
      },
    };

    window.localStorage.setItem('oauth_token', JSON.stringify(token));
    // dispatch({
    //   type: PARSE_AUTH,
    //   token: parameterMap.access_token,
    // });
    dispatch(setAccessToken(parameterMap.access_token));
    dispatch(fetchUser(token.oauth));
  };
};

const logout = function logout() {
  return function logoutFunction(dispatch, getState) {
    const {
      api: { user },
    } = getState();
    if (window.onLogout) {
      window.onLogout({
        user: {
          id: get(user, 'data[0].id'),
        },
      });
    }

    dispatch(loadingActions.setStatus('logging out'));
    affiliateActions.clearAffiliateInfo();
    return dispatch({
      type: USER_LOGOUT,
      payload: {
        id: user ? user.data[0].id : null,
      },
    });
  };
};

export default {
  login,
  logout,
  performAuth,
  parseAuth,
};



// WEBPACK FOOTER //
// ./src/state/actions/auth.js